import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './Specs.module.scss';

import Bar from '@/components/ui/Bar';
import LabelGroup from '@/components/ui/LabelGroup';

const cx = classNames.bind(styles);

const Specs = () => {
  const specs = useSelector((state) => state.mission.json.specs);

  const [protocol, firmware, frame] = useMemo(() => {
    let draftProtocol = '-';
    switch (specs.protocol) {
      case 'dji':
        draftProtocol = 'DJI';
        break;
      case 'mavlink':
        draftProtocol = 'MavLink';
        break;
      default:
        break;
    }

    let draftFirmware = '-';
    switch (specs.firmware) {
      case 'ardupilot':
        draftFirmware = 'ArduPilot';
        break;
      case 'px4':
        draftFirmware = 'PX4';
        break;
      default:
        break;
    }

    let draftFrame = '-';
    switch (specs.frame) {
      case 'boat':
        draftFrame = 'Boat';
        break;
      case 'copter':
        draftFrame = 'Copter';
        break;
      case 'vtol':
        draftFrame = 'Plane (VTOL)';
        break;
      case 'fixedwing':
        draftFrame = 'Plane (Fixed-wing)';
        break;
      case 'rover':
        draftFrame = 'Rover';
        break;
      default:
        break;
    }

    return [draftProtocol, draftFirmware, draftFrame];
  }, [specs]);

  return (
    <div className={cx('container')}>
      <LabelGroup label="Protocol" labelFontSize={10}>
        <div className={cx('value')}>{protocol}</div>
      </LabelGroup>
      <Bar size={28} />
      <LabelGroup label="Firmware" labelFontSize={10}>
        <div className={cx('value')}>{firmware}</div>
      </LabelGroup>
      <Bar size={28} />
      <LabelGroup label="Frame" labelFontSize={10}>
        <div className={cx('value')}>{frame}</div>
      </LabelGroup>
    </div>
  );
};

export default Specs;
